import * as angular from "angular";
import * as _ from "lodash";
import * as moment from "moment";
import {OrderRequestsService} from "../../orders/services/order-requests.service";
import {OmsOrdersAlertsService} from "./oms-orders-alerts.service";
import {OmsRequestsService} from "./oms-requests.service";
import {AccountModel} from "../../account/angular/models/account.model";
import {SiteContextService} from "../../commons/services/site-context.service";
import {SplitService} from "../../commons/services/split-service.service";
import {CommonsService} from "../../commons/services/commons-service.service";
import {DeliveriesService} from "../../deliveries/services/deliveries-service.service";
import {CancellationReasonVisibilitiesType} from "../../cancellation-reasons/types/cancellationReasonVisibilities.type";
import {CancellationReasonType} from "../../cancellation-reasons/types/cancellation-reason.type";
import {ActionReasonEnum} from "../../action-reasons/enums/action-reason.enum";
import {ActionReasonVisibilityEnum} from "../../action-reasons/enums/action-reason-visibility.enum";
import {ActionReasonModel} from "../../action-reasons/models/action-reason.model";
import {ActionReasonEntityEnum} from "../../action-reasons/enums/action-reason-entity.enum";
import {SettingsService} from "../../site-preferences/services/settings-service.service";

export class OmsDialogService {

  /* @ngInject */
  constructor(private $mdDialog, private $log, private $state, private omsOrdersAlertsService: OmsOrdersAlertsService,
              private orderRequestsService: OrderRequestsService, private omsRequestsService: OmsRequestsService, private commonsConstants,
              private siteContextService: SiteContextService, private splitService: SplitService,
              private settingsService: SettingsService) {
  }

  importOrders(event, account?, schemas?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/tmpl/import-orders-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: false,
      fullscreen: true,
      controller: function ($scope, omsConstants) {

        $scope.accountId = _.get(account, 'id');
        $scope.loading = false;
        $scope.file = undefined;

        $scope.schemaOptionsWrapper = {
          list: schemas?.map(s => {
            return {id: s.id, name: s.schemaName}
          }), propertyRef: 'name'
        };

        // Init Default Account
        if (account) {
          $scope.favouriteAccountName = _.get(account, 'name');
        }

        $scope.cancel = self.$mdDialog.cancel;
        $scope.onAccountSelect = onAccountSelect;
        $scope.onAddFile = onAddFile;
        $scope.onDownloadExample = onDownloadExample;

        $scope.onSelectSchema = (schemaId) => {
          $scope.schemaId = schemaId;
        }

        $scope.onUpload = () => {
          if ($scope.file) {
            $scope.loading = true;

            self.omsRequestsService.uploadOrdersExcel($scope.file, $scope.accountId, $scope.schemaId)
              .then((response) => {
                self.$mdDialog.hide(response);
              })
              .catch((error) => {
                self.omsOrdersAlertsService.uploadError();
                self.$log.error('Failed to upload excel to server, ' +
                  'importOrders@uploadFiles' + error);
              })
              .finally(() => {
                $scope.loading = false;
              })
          }
        };

        ///////////////////////////////////////////////////////////

        function onAccountSelect(account: AccountModel) {
          $scope.accountId = _.get(account, 'id');
        }

        function onAddFile(file) {
          $scope.file = file;
        }

        function onDownloadExample() {
          let downloadUrl = omsConstants.importSampleFileLink;
          let a = document.createElement("a");
          a.href = downloadUrl;
          a.download = "import-orders-example.xls";
          document.body.appendChild(a);
          a.click();
        }

      }
    })
  }

  scheduleDeliveries(event) {

    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/tmpl/schedule-delivery-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope) {

        $scope.date = new Date();
        $scope.notBefore = moment($scope.date).startOf('day').valueOf();
        $scope.notAfter = moment($scope.date).endOf('day').set({
          'minute': 30,
          'second': 0,
          'millisecond': 0
        }).valueOf();
        $scope.noTags = {
          enabled: false
        }

        $scope.cancel = self.$mdDialog.cancel;
        $scope.onTimeAndDateChange = onTimeAndDateChange;

        $scope.onSubmit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide({
                programType: 'SameDay',
                notBefore: $scope.notBefore,
                notAfter: $scope.notAfter,
                noTags: $scope.noTags.enabled
              });
            }
          }
        };

        // ******************************
        // External methods
        // ******************************

        function onTimeAndDateChange(from, to) {
          $scope.notBefore = from;
          $scope.notAfter = to;
        }
      }
    })
  }

  scheduleSelfPickup(event, order) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/tmpl/schedule-order-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope, vehicleTypes, VehiclesConstants) {

        $scope.vehicleTypes = vehicleTypes;
        $scope.vehiclePricingTypes = VehiclesConstants.vehiclePricingTypes;
        $scope.vehicleMakes = VehiclesConstants.makes;
        $scope.vehicleColors = VehiclesConstants.colors;

        $scope.selfPickup = {
          accountId: order.accountId,
          depotId: order.depot ? order.depot.id : undefined,
          status: undefined,
          type: 'InStore', // InStore | Curbside
          notBefore: order.dueFrom,
          notAfter: order.dueTo,
          comments: undefined,
          contact: angular.copy(order.contact),
          packages: [{items: []}]
        }

        $scope.cancel = self.$mdDialog.cancel;
        $scope.onSubmit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide({
                selfPickup: $scope.selfPickup,
                delivery: $scope.delivery
              });
            }
          }
        };

        $scope.onAccountSelect = onAccountSelect;
        $scope.onDepotSelect = onDepotSelect;
        $scope.onPhoneChange = onPhoneChange;
        $scope.onTimeAndDateChange = onTimeAndDateChange;
        $scope.onTypeChange = onTypeChange;

        $scope.onAddPackageItem = onAddPackageItem;
        $scope.onRemovePackageItem = onRemovePackageItem;

        // ******************************
        // External methods
        // ******************************

        function onAccountSelect(account: AccountModel) {
          $scope.selfPickup.accountId = _.get(account, 'id');
        }

        function onDepotSelect(depot) {
          $scope.selfPickup.depot = _.get(depot, 'id');
        }

        function onPhoneChange(phone) {
          $scope.selfPickup.contact.phoneNo = phone;
        }

        function onTimeAndDateChange(from, to) {
          $scope.selfPickup.notBefore = from;
          $scope.selfPickup.notAfter = to;
        }

        function onTypeChange(type) {
          if (type === 'Curbside') {
            $scope.selfPickup.vehicleInfo = {
              make: undefined,
              model: undefined,
              color: undefined,
              plateNumber: undefined
            };
          } else {
            _.unset($scope.selfPickup, 'vehicleInfo')
          }
        }

        function onAddPackageItem(item) {
          $scope.selfPickup.packages[0].items.push(item);
        }

        function onRemovePackageItem(index) {
          $scope.selfPickup.packages[0].items.splice(index, 1);
        }
      }
    })
  }

  createAutomaticShipmentRule(event?) {
    const self = this;
    return this.$mdDialog.show({
      controller: function ($scope, omsConstants, accountTypes) {

        $scope.header = 'Delivery/Service Creation Rules';
        $scope.action = 'Create';

        $scope.accountTypeOptions = accountTypes.demand;
        $scope.ruleTypes = omsConstants.autoShipmentCreationRuleTypes;
        $scope.rule = {
          name: undefined,
          type: undefined,
          accountTypes: [],
          branchIds: [],
          accountIds: []
        };

        $scope.onBranchesChange = onBranchesChange;
        $scope.onAccountsChange = onAccountsChange;
        $scope.onRuleTypeChange = onRuleTypeChange;
        $scope.onAccountTypeChange = onAccountTypeChange;

        $scope.cancel = self.$mdDialog.cancel;

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide($scope.rule);
            }
          } else {
            self.$log.error('Form resolved to undefined!. \n' +
              '--> adminDialogService@createNewAdmin  @submit')
          }
        };

        ////////////////////////////////////////////////////////////////////////////////////////////////////

        function onBranchesChange(branchIds) {
          $scope.rule.branchIds = branchIds;

          if ($scope.rule.accountIds.length) {
            $scope.rule.accountIds = [];
          }
        }

        function onAccountsChange(accountIds) {
          $scope.rule.accountIds = accountIds;
        }

        function onRuleTypeChange(selectedType) {
          $scope.rule.type = selectedType;
        }

        function onAccountTypeChange(accountTypes) {
          $scope.rule.accountTypes = accountTypes;
        }
      },
      template: require('./../views/tmpl/automatic-shipment-rule-dialog.html').default,
      parent: angular.element(document.body),
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true
    });
  }

  updateAutomaticShipmentRule(rule, event?) {
    const self = this;
    return this.$mdDialog.show({
      controller: function ($scope, omsConstants, accountTypes) {

        $scope.header = 'Delivery/Service Creation Rules';
        $scope.action = 'Save';

        $scope.accountTypeOptions = accountTypes.demand;
        $scope.ruleTypes = omsConstants.autoShipmentCreationRuleTypes;
        $scope.rule = angular.copy(rule);

        if (!$scope.rule.accountTypes) {
          $scope.rule.accountTypes = [];
        }

        if (!$scope.rule.branchIds) {
          $scope.rule.branchIds = [];
        }

        if (!$scope.rule.accountIds) {
          $scope.rule.accountIds = [];
        }

        $scope.onBranchesChange = onBranchesChange;
        $scope.onAccountsChange = onAccountsChange;
        $scope.onRuleTypeChange = onRuleTypeChange;
        $scope.onAccountTypeChange = onAccountTypeChange;

        $scope.cancel = self.$mdDialog.cancel;
        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide($scope.rule)

            }
          } else {
            self.$log.error('Form resolved to undefined!. \n' +
              '--> adminDialogService@createNewAdmin  @submit')
          }
        };

        ////////////////////////////////////////////////////////////////////////////////////////////////////

        function onBranchesChange(branchIds) {
          $scope.rule.branchIds = branchIds;

          if ($scope.rule.accountIds.length) {
            $scope.rule.accountIds = [];
          }
        }

        function onAccountsChange(accountIds) {
          $scope.rule.accountIds = accountIds;
        }

        function onRuleTypeChange(selectedType) {
          $scope.rule.type = selectedType;
        }

        function onAccountTypeChange(accountTypes) {
          $scope.rule.accountTypes = accountTypes;
        }

      },
      template: require('./../views/tmpl/automatic-shipment-rule-dialog.html').default,
      parent: angular.element(document.body),
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true
    });
  }

  confirmReschedulingForm(event?, orderIds?: string[]) {
    const self = this;
    return this.$mdDialog.show({
      template: require('./../views/tmpl/confirm-rescheduling-form-dialog.html').default,
      parent: angular.element(document.body),
      targetEvent: event,
      clickOutsideToClose: false,
      fullscreen: true,
      controller: function ($scope) {

        $scope.orderIds = orderIds;
        $scope.cancel = self.$mdDialog.cancel;
        ////////////////////////////////////////////////////////////////////////////////////////////////////////////////

        $scope.no = () => {
          self.$mdDialog.hide(false);
        }
        $scope.yes = () => {
          self.$mdDialog.hide(true);
        }
      }
    });
  }

  createAutomaticQuote(event?) {
    const self = this;
    return this.$mdDialog.show({
      controller: function ($scope, omsConstants, splitService) {

        $scope.header = 'New 3rd-Party quote request rule';
        $scope.action = 'Create';

        $scope.suppliers = omsConstants.supplierTypes;
        $scope.slaInHours = undefined;
        $scope.distanceFactor = splitService.getSiteDistanceLargeUnit(true);
        $scope.weightFactor = splitService.getWeightUnit();
        $scope.volumeFactor = splitService.getVolumeUnit();

        $scope.quote = {
          name: undefined,
          sla: undefined,
          orderDistance: undefined,
          weight: undefined,
          volume: undefined,
          supplierTypes: [],
          serviceAreaIds: []
        };

        $scope.cancel = self.$mdDialog.cancel;
        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              if ($scope.slaInHours) {
                $scope.quote.sla = _toMiliseconds($scope.slaInHours);
              }
              self.$mdDialog.hide($scope.quote)

            }
          } else {
            self.$log.error('Form resolved to undefined!. \n' +
              '--> adminDialogService@createNewAdmin  @submit')
          }
        };

        ////////////////////////////////////////////////////////////////////////////////////////////////////

        $scope.onBranchesChange = (branchIds) => {
          $scope.quote.branchIds = branchIds;
        }

        $scope.onSuppliersChange = (supplierTypes) => {
          $scope.quote.supplierTypes = supplierTypes;
        }

        $scope.onServiceAreasChange = (serviceAreaIds) => {
          $scope.quote.serviceAreaIds = serviceAreaIds;
        }

        function _toMiliseconds(hours) {

          if (!hours) {
            return undefined;
          }

          const MILLISECOND = 1000,
            SECOND = 60,
            MINUTE = 60;

          return Number((hours * MINUTE * SECOND * MILLISECOND).toFixed(1));
        }
      },
      template: require('./../views/tmpl/automatic-quote-dialog.html').default,
      parent: angular.element(document.body),
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true
    });
  }

  updateAutomaticQuote(quote, event?) {
    const self = this;
    return this.$mdDialog.show({
      controller: function ($scope, omsConstants, splitService) {

        $scope.header = 'New 3rd-Party quote request rule';
        $scope.action = 'Save';

        $scope.suppliers = omsConstants.supplierTypes;
        $scope.slaInHours = _toHours(_.get(quote, 'sla'));
        $scope.distanceFactor = splitService.getSiteDistanceLargeUnit(true);
        $scope.weightFactor = splitService.getWeightUnit();
        $scope.volumeFactor = splitService.getVolumeUnit();

        $scope.quote = angular.copy(quote);

        $scope.cancel = self.$mdDialog.cancel;
        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              if ($scope.slaInHours) {
                $scope.quote.sla = _toMiliseconds($scope.slaInHours);
              }
              self.$mdDialog.hide($scope.quote)
            }
          } else {
            self.$log.error('Form resolved to undefined!. \n' +
              '--> adminDialogService@createNewAdmin  @submit')
          }
        };

        ////////////////////////////////////////////////////////////////////////////////////////////////////

        $scope.onBranchesChange = (branchIds) => {
          $scope.quote.branchIds = branchIds;
        }

        $scope.onSuppliersChange = (supplierTypes) => {
          $scope.quote.supplierTypes = supplierTypes;
        }

        $scope.onServiceAreasChange = (serviceAreaIds) => {
          $scope.quote.serviceAreaIds = serviceAreaIds;
        }

        function _toHours(milliseconds) {

          if (!milliseconds) {
            return undefined;
          }

          const SECOND = 1000,
            MINUTE = 60,
            HOUR = 60;

          return Number((milliseconds / SECOND / MINUTE / HOUR).toFixed(1));
        }

        function _toMiliseconds(hours) {

          if (!hours) {
            return undefined;
          }

          const MILLISECOND = 1000,
            SECOND = 60,
            MINUTE = 60;

          return Number((hours * MINUTE * SECOND * MILLISECOND).toFixed(1));
        }

      },
      template: require('./../views/tmpl/automatic-quote-dialog.html').default,
      parent: angular.element(document.body),
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true
    });
  }

  assignOrder(orderId, event?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/tmpl/assign-order-dialog.html').default,
      controller: function ($scope, omsRequestsService, splitService) {

        // $scope.shipment = angular.copy(shipment);
        $scope.data = undefined;
        $scope.selectedIds = [];
        $scope.loading = false;

        $scope.weightFactor = splitService.getWeightUnit();
        $scope.volumeFactor = splitService.getVolumeUnit();

        initTable();

        $scope.cancel = self.$mdDialog.cancel;
        $scope.submit = (supplier) => {
          self.$mdDialog.hide(supplier);
        };

        ///////////////////////////////////////////////////////////////

        function initTable() {
          $scope.suppliers = [];
          $scope.selectedIds = [];
          $scope.loading = true;

          omsRequestsService.get3plsAssignOptions(orderId)
            .then((res) => {
              $scope.data = res;
            })
            .finally(() => {
              $scope.loading = false;
            });
        }

      },
      targetEvent: event,
      clickOutsideToClose: false
    })
  }

  approvePriceOffer(priceOffer, order, event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/tmpl/approve-price-offer-dialog.html').default,
      controller: function ($scope, omsRequestsService, splitService) {

        $scope.order = order;
        $scope.priceOffer = priceOffer;
        const additionLines = _.get(priceOffer, '[0].priceDetails.additionLines', []);

        $scope.additionLines = _.filter(additionLines, (line) => {
          return !!line.count
        })

        const priceDetailLines = _.get(priceOffer, '[0].priceDetails.priceDetailLines', []);
        const priceAdditionLines = _.get(priceOffer, '[0].priceDetails.additionLines', []);

        $scope.totalPrice = _.reduce(_.concat(priceAdditionLines, priceDetailLines), (sum, priceLine) => {
          var discount = _.get(priceLine, 'discount', 0);
          var price = _.get(priceLine, 'price', 0);
          var count = _.get(priceLine, 'count', 0);
          var calculatedPrice = (price + discount) * count;

          return sum + calculatedPrice;
        }, 0);

        $scope.cancel = self.$mdDialog.cancel;
        ///////////////////////////////////////////////////////////////

        $scope.onSubmit = (form, doDispatch?) => {
          self.$mdDialog.hide(doDispatch);
        }

      },
      targetEvent: event,
      clickOutsideToClose: false
    })
  }

  addNote(event, orderId) {
    const self = this;
    return this.$mdDialog.show({
      template: require('./../views/tmpl/add-note-dialog.html').default,
      parent: angular.element(document.body),
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope, commonsService: CommonsService, $log) {

        $scope.orderId = orderId;
        $scope.note = {
          title: '',
          text: '',
          attachments: []
        };


        $scope.cancel = self.$mdDialog.cancel;
        ////////////////////////////////////////////////////////////////////////////////////////////////////////////////

        $scope.onAddAttachment = () => {
          commonsService.fileUpload(self.commonsConstants.fileConstants.upload.images)
            .then((result) => {
              _afterUpload(result);
            })
            .catch(() => {
              $log.info('Closed File Upload')
            })
        }

        function _afterUpload(uploadedResult) {
          const imageUrl = _.get(uploadedResult, 'url'),
            mimeType = _.get(uploadedResult, 'contentType');

          if (imageUrl) {
            const attachment = {
              url: imageUrl,
              mimeType: mimeType
            };
            $scope.note.attachments.push(attachment);
          }
        }

        $scope.onRemoveAttachment = (index) => {
          $scope.note.attachments.splice(index, 1);
        }

        $scope.onSubmit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide($scope.note);
            }
          }
        }

      }
    });
  }

  validateServiceAreas(isEditPriceEnabled?, event?) {
    const self = this;
    return this.$mdDialog.show({
      template: require('./../views/tmpl/validate-service-areas.html').default,
      parent: angular.element(document.body),
      targetEvent: event,
      clickOutsideToClose: false,
      fullscreen: true,
      multiple: true,
      controller: function ($scope) {
        $scope.isEditPriceEnabled = isEditPriceEnabled || true;

        $scope.cancel = self.$mdDialog.cancel;
        ////////////////////////////////////////////////////////////////////////////////////////////////////////////////

        $scope.onSubmit = (editPrice) => {
          self.$mdDialog.hide(editPrice);
        }

      }
    });
  }

  createOrderFailed() {
    const self = this;
    return this.$mdDialog.show({
      template: require('./../views/tmpl/create-order-failure.html').default,
      parent: angular.element(document.body),
      targetEvent: event,
      clickOutsideToClose: false,
      fullscreen: true,
      multiple: true,
      controller: function ($scope) {


        $scope.cancel = self.$mdDialog.cancel;
        ////////////////////////////////////////////////////////////////////////////////////////////////////////////////

        $scope.onSubmit = (editPrice) => {
          self.$mdDialog.hide(editPrice);
        }

      }
    });
  }

  createBasicOrder(account?: AccountModel) {
    const self = this;
    // Same metadata resolve as the 'order-create' state
    return this.settingsService.getSiteMetadata()
      .then(() => {
        return self.$mdDialog.show({
          // No targetEvent: the dialog would inherit the top-nav toolbar theme instead of the content theme
          template: require('./../views/tmpl/create-basic-order-dialog.html').default,
          parent: angular.element(document.body),
          clickOutsideToClose: false,
          fullscreen: true,
          controller: function ($scope) {

            $scope.account = account;

            $scope.cancel = self.$mdDialog.cancel;
            ////////////////////////////////////////////////////////////////////////////////////////////////////////////

            $scope.onCreated = (order, isDraft: boolean) => {
              self.$mdDialog.hide({order, isDraft});
            }

            $scope.onAdvanced = (order) => {
              self.$mdDialog.cancel({isAdvanced: true, order});
            }

          }
        });
      });
  }

  editCompletedOrder(order) {
    const self = this;
    return this.$mdDialog.show({
      template: require('./../views/tmpl/edit-completed-order.html').default,
      parent: angular.element(document.body),
      targetEvent: event,
      clickOutsideToClose: false,
      fullscreen: true,
      controller: function ($scope, splitService) {

        $scope.order = order;
        $scope.isReferenceIdsMandatory = splitService.isReferenceIdsMandatory();
        $scope.weightUnit = self.splitService.getWeightUnit();
        $scope.cancel = self.$mdDialog.cancel;
        ////////////////////////////////////////////////////////////////////////////////////////////////////////////////

        $scope.onReferenceIdsChange = (referenceIds) => {
          $scope.order.referenceIds = referenceIds;
        }

        $scope.onSubmit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide($scope.order);
            }
          }
        }

      }
    });
  }

  onSetOrderOnHold() {
    const self = this;
    return this.$mdDialog.show({
      template: require('./../views/tmpl/set-order-on-hold-dialog.html').default,
      parent: angular.element(document.body),
      targetEvent: event,
      clickOutsideToClose: false,
      fullscreen: true,
      controller: function ($scope) {
        $scope.description = "";

        $scope.cancel = self.$mdDialog.cancel;
        ////////////////////////////////////////////////////////////////////////////////////////////////////////////////

        $scope.onSubmit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide($scope.description);
            }
          }
        }

      }
    });
  }

  onResumeOrder() {
    const self = this;
    return this.$mdDialog.show({
      template: require('./../views/tmpl/resume-order-dialog.html').default,
      parent: angular.element(document.body),
      targetEvent: event,
      clickOutsideToClose: false,
      fullscreen: true,
      controller: function ($scope) {

        $scope.cancel = self.$mdDialog.cancel;
        ////////////////////////////////////////////////////////////////////////////////////////////////////////////////

        $scope.no = () => {
          self.$mdDialog.hide(false);
        }
        $scope.yes = () => {
          self.$mdDialog.hide(true);
        }
      }
    });
  }

  onCreateReturnDeliveryOrder(newOrder, duplicatedFulfillmentLine) {
    const self = this;
    return this.$mdDialog.show({
      template: require('./../views/tmpl/order-return-delivery-dialog.html').default,
      parent: angular.element(document.body),
      targetEvent: event,
      clickOutsideToClose: false,
      fullscreen: true,
      controller: function ($scope) {

        $scope.order = newOrder;
        $scope.duplicatedFulfillmentLine = duplicatedFulfillmentLine;
        $scope.tabIndex = 0;
        $scope.isWeightInTotal = self.siteContextService.getSiteInfo().isOmsPackageTotalWeight;

        $scope.cancel = self.$mdDialog.cancel;
        ////////////////////////////////////////////////////////////////////////////////////////////////////////////////

        $scope.onOrderChange = (order) => {
          $scope.order = order;
        }

        $scope.onTabSelect = (index) => {
          $scope.tabIndex = index
        }

        $scope.onNext = () => {
          $scope.tabIndex = $scope.tabIndex + 1;
        }

        $scope.onBack = () => {
          $scope.tabIndex = $scope.tabIndex - 1;
        }

        $scope.onAdvancedOrderCreation = () => {
          self.$mdDialog.cancel({isAdvanced: true, order: $scope.order});
        }

        $scope.onSubmit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide($scope.order);
            }
          }
        }

      }
    });
  }

  bulkEditOrders(ordersCount, status?) {
    const self = this;
    return this.$mdDialog.show({
      template: require('./../views/tmpl/bulk-edit-orders-dialog.html').default,
      parent: angular.element(document.body),
      targetEvent: event,
      clickOutsideToClose: false,
      fullscreen: true,
      controller: function ($scope) {

        $scope.ordersCount = ordersCount;
        $scope.isHideLinesSection = status === 'Completed';

        $scope.cancel = self.$mdDialog.cancel;

        $scope.sections = {
          orderDetails: false,
          lineOrigin: false,
          lineDestination: false
        }

        $scope.payload = {
          accountId: undefined,
          programTypes: [],
          lineTypes: [],
          referenceIds: [],
          pickupTask: {
            contact: {},
            location: {
              locationType: "CUSTOM",
              address: {}
            }
          },
          destinationTask: {
            contact: {},
            location: {
              locationType: "CUSTOM",
              address: {}
            }
          }
        }

        $scope.onSectionsChange = (sections) => {
          $scope.sectionsCopy = angular.copy(sections);
          $scope.sections = $scope.sectionsCopy;
        }

        $scope.onPayloadChange = (payload) => {
          $scope.payloadCopy = angular.copy(payload);
          $scope.payload = $scope.payloadCopy;
        }

        $scope.onSubmit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              if (!$scope.sections.orderDetails) {
                _.unset($scope.payload, 'referenceIds');
              }
              if (!$scope.sections.lineOrigin) {
                _.unset($scope.payload, 'pickupTask');
              }
              if (!$scope.sections.lineDestination) {
                _.unset($scope.payload, 'destinationTask');
              }
              self.$mdDialog.hide($scope.payload);
            }
          }
        }

      }
    });
  }

  createOrderCancellationReason(event?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/tmpl/order-cancellation-reason.html').default,
      controller: function ($scope, commonsService: CommonsService, $log, $mdMedia) {

        $scope.cancellationReasonVisibilitiesType = CancellationReasonVisibilitiesType;
        $scope.isMobile = !$mdMedia('gt-md');

        $scope.cancellationReasonTypes = [CancellationReasonType.Order];

        $scope.actionReasonTypes = [ActionReasonEnum.Cancel];
        $scope.actionReasonVisibiltyTypes = ActionReasonVisibilityEnum;
        $scope.actionReasonEntityTypes = ActionReasonEntityEnum;

        $scope.onChangeCancellationReason = (cancellationReason: ActionReasonModel) => {
          if (!cancellationReason) {
            $scope.orderCancellationReason = undefined;
          } else {
            $scope.orderCancellationReason = {};
            $scope.orderCancellationReason.reason = cancellationReason.reason;
            $scope.orderCancellationReason.externalId = cancellationReason.externalId;
            $scope.orderCancellationReason.description = cancellationReason.description;
            $scope.orderCancellationReason.actions = cancellationReason.actions;
          }

          $scope.selectedCancellationReason = cancellationReason;
        }

        $scope.onAddAttachment = () => {
          commonsService.fileUpload(self.commonsConstants.fileConstants.upload.images)
            .then((result) => {
              $scope._afterUpload(result);
            })
            .catch(function () {
              $log.info('Closed File Upload')
            })
        }

        $scope.onRemoveAttachment = (index) => {
          $scope.cancelTaskReason.attachments.splice(index, 1);
        }

        $scope._afterUpload = (uploadedResult) => {
          const imageUrl = _.get(uploadedResult, 'url'),
            mimeType = _.get(uploadedResult, 'contentType');

          if (imageUrl) {
            const attachment = {
              url: imageUrl,
              mimeType: mimeType
            };
            $scope.cancelTaskReason.attachments.push(attachment);
          }
        }

        $scope.cancel = self.$mdDialog.cancel;

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide($scope.orderCancellationReason);
            }
          }
        };
      },
      targetEvent: event,
      fullscreen: true,
      clickOutsideToClose: false
    })
  }

  blockedOrderEditReasonsList(reasons: string[]) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/tmpl/blocked-order-edit-reasons-list-dialog.html').default,
      controller: function ($scope) {

        $scope.reasons = reasons;

        //////////////////////

        $scope.continue = () => {
          self.$mdDialog.hide();
        }

      },
      targetEvent: event,
      clickOutsideToClose: true
    });

  }


}

angular
  .module('bringoz.admin.oms')
  .service('omsDialogService', OmsDialogService);
